import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

const HeroBanner = ({src, srcSet, sizes="100vw", className}) => {
  return(
    <img 
      src={src} 
      srcSet={srcSet} 
      sizes={sizes} 
      className={className}
      fluid 
      // Professional additions for Hero banners:
      loading="eager" // Hero images should load immediately
      fetchpriority="high" // Tells the browser this is the most important image
    />
    // <Image src={src} fluid />
  )
}

export default HeroBanner;